import React, { useEffect, useRef, useState } from 'react';
import CustomTable from '../../components/customTable/CustomTable';
import SplitButton from 'react-bootstrap/SplitButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import '../categories/SubCategories.scss';
import CloseIcon from '../../assets/images/CloseIcon.png';
import ImageIcon from '../../assets/images/image-upload-icon.png';
import Switch from 'react-switch';
import DropdownArrow from '../../assets/images/DropdownArrow.png';
import { useDispatch, useSelector } from 'react-redux';
import { getMasterItems, getActivity, createSubCategories, deleteSubCategories, updateSubCategories, updateCategoryStatus, getSearchCategories, getUploadUrl } from './slice/slice';
import Loader from '../../components/loader/Loader';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

function SubCategory() {

    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [checked, setChecked] = useState(false);
    const [options, setOptions] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Select the type');
    const [modalSelectedOption, setModalSelectedOption] = useState('Select the type');
    const dropdownRef = useRef(null);
    const { isLoading, getMasterItemsDetails, getActivityList, searchCategories } = useSelector(state => state.CategoriesSlice);
    const [isModalOpen3, setIsModalOpen3] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [previewUrl, setPreviewUrl] = useState(null);

    const schema = yup.object().shape({
        name: yup.string().required("Please enter category name"),
        type: yup.string().required("Please select category type"),
        image: yup.string().required("Please add an image"),
    })

    const { control, handleSubmit, setValue, getValues, formState: { errors }, reset: resetForm } = useForm({
        resolver: yupResolver(schema)
    })

    const handleSearchChange = (newSearchText) => {
        setSearchText(newSearchText);
    };

    useEffect(() => {
        if (searchText) {
            const searchedData = { search_query: searchText }
            dispatch(getSearchCategories(searchedData));
        }
    }, [dispatch, searchText]);

    useEffect(() => {
        dispatch(getMasterItems());
    }, [dispatch]);

    useEffect(() => {
        if (getMasterItemsDetails) {
            const optionsData = getMasterItemsDetails.map(item => ({ name: item.name, id: item.id }));
            setOptions(optionsData);
            setSelectedOption('All');
            dispatch(getActivity());
        }
    }, [getMasterItemsDetails, dispatch]);

    const handleSelectOption = (eventKey) => {
        if (eventKey === 'all') {
            setSelectedOption('All');
            dispatch(getActivity());
        } else {
            const option = options[eventKey];
            setSelectedOption(option.name);
            dispatch(getActivity(`?type=${option.id}`));
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const typeMapping = {
        1: 'Health',
        2: 'Emotional Wellbeing',
        3: 'Academic & Work Wellness',
        4: 'Fitness'
    };

    const transformData = (data) => data.map(item => ({
        id: item.id,
        mastercategory: {
            icon: item?.image.startsWith('http') ? item.image : `${process.env.REACT_APP_IMAGE_URL}/${item?.image}`,
            text: item.name
        },
        type: typeMapping[item.type] || item.type,
        status: item.is_active ? 'Active' : 'Inactive',
    }));

    const transformSearchData = (data) => data?.map(item => ({
        id: item.id,
        mastercategory: {
            icon: item?.image.startsWith('http') ? item.image : `${process.env.REACT_APP_IMAGE_URL}/${item?.image}`,
            text: item.name
        },
        type:  typeMapping[item.type] || item.type,
        status: item.is_active ? 'Active' : 'Inactive',
    }));

    const userData = transformData(getActivityList);
    const searchdata = transformSearchData(searchCategories);

    const onSubmit = async (data) => {
        try {
            if (selectedFile) {
                await dispatch(getUploadUrl(`?file_name=${selectedFile.fileName}&file_type=${selectedFile.type}`)).unwrap()
                    .then(async (res) => {
                        const response = await fetch(res.url, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': selectedFile.type,
                            },
                            body: selectedFile.file
                        });
                        if (response.status === 200) {
                            data.image = selectedFile.fileName;

                            if (isEditMode) {
                                const updatedata = { ...data, id: selectedId };
                                await dispatch(updateSubCategories(updatedata)).unwrap();
                                toast.success('Sub category updated successfully');
                            } else {
                                await dispatch(createSubCategories(data)).unwrap();
                                toast.success("Sub category created successfully!");
                            }
                            setIsModalOpen3(false);
                            dispatch(getActivity());
                            resetForm();
                        } else {
                            throw new Error('Failed to upload image');
                        }
                    })
                    .catch((error) => {
                        toast.error(error.message || 'Upload image failed');
                        return;
                    });
            }
            else if (isEditMode && !selectedFile) {
                const updatedata = { ...data, id: selectedId };
                await dispatch(updateSubCategories(updatedata)).unwrap()
                    .then((res) => {
                        toast.success('Sub category updated successfully');
                        setIsModalOpen3(false);
                        dispatch(getActivity());
                        resetForm();
                    })
                    .catch((error) => {
                        toast.error(error.message || 'Failed to update category');
                        return;
                    });
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to save sub category');
            setIsModalOpen3(false);
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        const fileUrl = URL.createObjectURL(file);
        if (file) {
            const currentEpochSeconds = Math.floor(Date.now() / 1000);
            const fileName = file.name || `Image_${currentEpochSeconds}.${file.type?.split("/")[1]}`;
            setSelectedFile({ fileName, type: file.type, file });
            setValue('image', fileName);
            setPreviewUrl(fileUrl);
        }
    };

    const handleModalSelectOption = (option) => {
        setModalSelectedOption(option.name);
        setValue('type', option.id);
        setIsOpen(false);
    };

    const handleEditClick = (rowData) => {
        setSelectedRow(rowData);
        setSelectedId(rowData.id);
        setValue('name', rowData.mastercategory.text);
        setValue('type', rowData.type);

        const imageFileName = rowData.mastercategory.icon.replace(`${process.env.REACT_APP_IMAGE_URL}`, "");
        setSelectedFile({ fileName: imageFileName });
        setValue('image', imageFileName);

        const imagePreviewUrl = rowData.mastercategory.icon;
        setPreviewUrl(imagePreviewUrl);

        setModalSelectedOption(rowData.type);
        setIsEditMode(true);
        setIsModalOpen3(true);
    };

    const handleDeleteClick = (rowData) => {
        setSelectedRow(rowData)
        setIsModalOpen2(true)
    }

    const deleteSubCategory = () => {
        if (selectedRow) {
            const id = selectedRow.id;
            dispatch(deleteSubCategories({ id }))
                .then((res) => {
                    dispatch(getActivity())
                    toast.success(res?.payload?.message || 'Sub category deleted');
                    setIsModalOpen2();
                })
                .catch(error => {
                    toast.error(error?.message, 'Failed to delete sub category');
                });
        }
    }

    const handleToggleClick = (rowData) => {
        const queryParam = `?id=${rowData.id}`;
        dispatch(updateCategoryStatus(queryParam))
            .then((res) => {
                toast.success(res?.payload?.message || 'User status updated successfully');
                dispatch(getActivity())
            })
            .catch(error => {
                toast.error('Failed to update user status' || error);
            });
    };

    const handleCloseModal = () => {
        setIsModalOpen3(false);
        resetForm();
        setModalSelectedOption('Select the type');
        setIsEditMode(false);
        setSelectedFile('')
        setPreviewUrl('')
    };

    const openAddModal = () => {
        setIsEditMode(false);
        resetForm();
        setModalSelectedOption('Select the type');
        setIsModalOpen3(true);
        setSelectedFile('')
        setPreviewUrl('')
    };

    const handleBrowseClick = () => {
        document.getElementById('fileInput').click();
    };

    return (
        <>
            {isLoading && <Loader />}
            <div className='subcategories main-Page-css' style={{ minHeight: '94vh' }}>
                <div className='tab-box'>
                    <p className='main-page-title'>Sub Categories</p>
                    <div style={{ marginBottom: 24 }} className='d-flex align-items-center justify-content-between'>
                        <SplitButton
                            align={{ lg: 'start' }}
                            title={selectedOption}
                            id="dropdown-menu-align-responsive-2"
                            onSelect={(eventKey) => handleSelectOption(eventKey)}
                        >
                            <Dropdown.Item eventKey="all" key="all">
                                All
                            </Dropdown.Item>
                            {options.map((option, index) => (
                                <Dropdown.Item eventKey={index} key={index}>
                                    {option.name}
                                </Dropdown.Item>
                            ))}
                        </SplitButton>
                        <button className='add-new-button' onClick={openAddModal}>Add Category</button>
                    </div>
                    <div>
                        <CustomTable
                            showTitle
                            titlehead='Sub Categories'
                            data={searchText ? searchdata : userData}
                            headers={['Id', 'Sub Categories', 'Type', 'Status']}
                            showSearchBar='true'
                            searchBarPlaceholder='Search by Sub Category'
                            actionsHeaderText='Action'
                            showActions
                            showEdit
                            showDeleteIcon
                            showPagination
                            showIcon={true}
                            showtablecss={true}
                            onEditClick={(rowData) => handleEditClick(rowData)}
                            onDeleteClick={(rowData) => handleDeleteClick(rowData)}
                            onSearchChange={handleSearchChange}
                            showSlider3
                            onToggleClick={(rowData) => handleToggleClick(rowData)}
                        />
                        <Modal size='lg' show={isModalOpen2} centered>
                            <Modal.Header style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                                <button className='imagebox cursor-pointer' onClick={() => setIsModalOpen2(false)}>
                                    <img src={CloseIcon} style={{ width: '24px', objectFit: 'contain' }} alt="Close" />
                                </button>
                            </Modal.Header>
                            <Modal.Body>
                                <div className='subcategories'>
                                    <p className='text-center warning-text'>Are you sure you want to delete the selected category?</p>
                                    <div className='d-flex justify-content-center' style={{ marginTop: 24 }}>
                                        <button className='cancel-btn'>Cancel</button>
                                        <button className='cancel-btn save-btn' onClick={deleteSubCategory}>Save</button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                        <Modal size='lg' show={isModalOpen3} centered>
                            <Modal.Header style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                <p className='modal-heading'>{isEditMode ? 'Edit Sub Category' : 'Add New Sub Category'}</p>
                                <button className='imagebox cursor-pointer' onClick={handleCloseModal}>
                                    <img src={CloseIcon} style={{ width: '24px', objectFit: 'contain' }} alt="Close" />
                                </button>
                            </Modal.Header>
                            <Modal.Body>
                                <div className='subcategories pt-2'>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className='row'>
                                            <div className='col-6'>
                                                <p className='label-head'>Sub Category Name</p>
                                                <Controller
                                                    name="name"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            type="text"
                                                            className="form-control mt-2"
                                                            placeholder="Enter category name" {...field}
                                                        />
                                                    )}
                                                />
                                                {errors.name && <p className="errorText">{errors.name.message}</p>}
                                                {/* <input type='text' placeholder='Enter Category Name' className='w-100 inputbox' /> */}
                                            </div>
                                            <div className='col-6'>
                                                <p className='label-head'>Type</p>
                                                <div className='dropdown-container'>
                                                    <div ref={dropdownRef} className="dropdown w-100">
                                                        <button onClick={(event) => { event.preventDefault(); setIsOpen(!isOpen) }} className={`dropdown-button inputbox`}>
                                                            {modalSelectedOption}
                                                            <img
                                                                src={DropdownArrow}
                                                                width="20px"
                                                                height="20px"
                                                                className='arrowstyle'
                                                                style={{ objectFit: 'contain', transform: isOpen ? 'rotate(180deg)' : 'rotate(0)' }}
                                                                alt="Dropdown Arrow"
                                                            />
                                                        </button>
                                                        {isOpen && (
                                                            <ul className="dropdown-menu1">
                                                                {options.map((option, index) => (
                                                                    <li key={index} onClick={() => handleModalSelectOption(option)} className="dropdown-item">
                                                                        {option.name}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </div>
                                                </div>
                                                {errors.type && <p className="errorText">{errors.type.message}</p>}
                                            </div>
                                        </div>
                                        <div className='browsebox col-3'>
                                            {previewUrl ? (
                                                <img src={previewUrl} style={{ width: '100%', objectFit: 'contain' }} alt="Selected" />
                                            ) : (
                                                <>
                                                    <img src={ImageIcon} style={{ width: '57px', objectFit: 'contain' }} alt="Upload" />
                                                    <p className='upload-text'>Click to upload</p>
                                                    <p className='imagehead'>Image</p>
                                                    <p className='imagewidth-text'>PNG (max 170 x 170)</p>
                                                </>
                                            )}
                                        </div>
                                        <div className='d-flex align-items-center'>
                                            <button type="button" className='browse-btn' onClick={handleBrowseClick}>
                                                Browse
                                            </button>
                                            <Controller
                                                name="image"
                                                control={control}
                                                render={({ field: { onChange, onBlur } }) => (
                                                    <input
                                                        id="fileInput"
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        onChange={handleFileChange}
                                                    />
                                                )}
                                            />
                                            {selectedFile &&
                                                (
                                                    <div style={{ marginTop: 24, marginLeft: 24 }}>
                                                        <p className='screnshot-text'>{selectedFile.fileName}</p>
                                                        <p className='added-text'>{isEditMode ? '' : `Added on ${new Date().toLocaleString()}`} </p>
                                                    </div>
                                                )
                                            }

                                        </div>
                                        {errors.image && <p className="errorText">{errors.image.message}</p>}
                                        <div className='d-flex justify-content-end' style={{ marginTop: 24 }}>
                                            <button className='cancel-btn' onClick={() => setIsModalOpen3(false)}>Cancel</button>
                                            <button className='cancel-btn save-btn' type='submit'>{isEditMode ? 'Update' : 'Save'}</button>
                                        </div>
                                    </form>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SubCategory;
